import { IconButton } from '../../Button';
import { ModalContainer } from '../../Modal';

export const VimeoVideo = ({
  onClose,
  isOpen,
  videoUrl,
}: {
  onClose: () => void;
  isOpen: boolean;
  videoUrl: string;
}) => {
  return (
    <ModalContainer
      close={onClose}
      isOpen={isOpen}
      className="flex flex-col justify-center items-center w-full bg-opacity-40 bg-black relative py-16"
    >
      <IconButton
        icon={'close'}
        onClick={onClose}
        theme={'text'}
        diameter={26}
        className={'z-50 absolute top-8 right-8'}
      />
      <div className="fixed inset-0 flex items-center justify-center" onClick={onClose}>
        {/* Wrapper to maintain aspect ratio and provide padding */}
        <div
          className="relative w-full max-w-[calc(100vh*9/16)] max-h-screen p-4 flex items-center justify-center"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Inner container with rounded corners and overflow hidden */}
          <div className="relative w-full h-0 pb-[177.78%] rounded-2xl overflow-hidden">
            {/* Iframe for Vimeo video */}
            <iframe
              src={videoUrl}
              allow="autoplay; fullscreen;"
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full border-none"
            ></iframe>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};
